import { FC } from 'react'
import cx from 'classnames'
import Styles from './Footer.module.scss'

const Footer: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className={cx(Styles.footer, { [Styles.hasChildren]: children })}>{children}</div>
)

export { Footer }
